import React, { useState, useEffect, useRef } from "react";
import { NewtaskCard } from "../TaskCard";
import { useDroppable } from "@dnd-kit/core";
import usePermission from "../../../../Core/hooks/usePermission";
import { useAppSelector } from "../../../../Core/redux/hooks";

const KanbanColumn = ({
  status,
  children,
  className,
  channel,
  parentTaskId = "",
  isBugs = false,
}) => {
  const { showNewTaskCard, showSubtaskView, collaboratorsForTask, goals } =
    useAppSelector((state) => state.schedule);
  const { user } = useAppSelector((state) => state.userDetails);
  const originalParentGoal = goals?.find((l) => +l.id == +parentTaskId);
  const [parentGoal, setParentGoal] = useState(originalParentGoal);
  const { setNodeRef, active, isOver, over } = useDroppable({
    id: status,
    data: { channel },
  });
  const [isHovered, setIsHoverd] = useState(false);

  const { hasPermission: TASK_EVENT_SCOPE_ADD } = usePermission("8");

  const shouldShowNewTaskCard = () => {
    if (!parentGoal && status && TASK_EVENT_SCOPE_ADD) {
      return true;
    }
    if (parentGoal && parentGoal.collaborators.includes(user.id)) {
      return true;
    }
    return false;
  };

  return (
    <div
      ref={setNodeRef}
      className={`h-full  ${
        !showSubtaskView ? (!isHovered ? "pb-[40px]" : "") : ""
      }  ${className}`}
      onMouseEnter={() => {
        setIsHoverd(true);
      }}
      onMouseLeave={() => setIsHoverd(false)}
    >
      {children}
      {shouldShowNewTaskCard() && (
        <div>
          <NewtaskCard
            status={channel}
            isHovered={
              !showSubtaskView
                ? isHovered
                : +channel?.statusId === 1
                ? true
                : false
            }
            parentTaskId={showSubtaskView ? parentTaskId : ""}
            isBugs={isBugs}
          />
        </div>
      )}
    </div>
  );
};

export default KanbanColumn;
